// assets/sku-search-normalizer.js
//
// Normalizes search queries for Bionika SKU format:
//   - Strips trailing 'S' or 'A' suffix (label-only indicators for assembled / alternative variants)
//   - Adds dots to 12-digit numbers to match XXX.XXX.XXX.XXX format
//   - Leaves 13-14 digit UDI codes alone (no dot-adding)
//
// Bypass with ?no_normalize=1 in URL.

(function () {
  if (new URLSearchParams(location.search).get('no_normalize') === '1') return;

  // Step 1: Strip 'S' or 'A' suffix from a 12-digit SKU (with or without separators)
  const SKU_WITH_SUFFIX = /(\b\d{3}[\.\s\-]?\d{3}[\.\s\-]?\d{3}[\.\s\-]?\d{3})\s*[SsAa]\b/g;

  // Step 2: Normalize 12-digit SKU to dot-separated form
  // The \b word boundaries at both ends ensure 13+ digit UDIs are NOT matched
  const SKU_TO_DOTS = /\b(\d{3})[\.\s\-]?(\d{3})[\.\s\-]?(\d{3})[\.\s\-]?(\d{3})\b/g;

  function normalize(query) {
    if (!query) return query;
    query = query.replace(SKU_WITH_SUFFIX, '$1');
    query = query.replace(SKU_TO_DOTS, '$1.$2.$3.$4');
    return query;
  }

  function getReason(original, normalized) {
    if (original === normalized) return '';
    const reasons = [];

    // Was a suffix stripped?
    const suffixMatch = original.match(/\d[\d\.\s\-]*\s*([SsAa])\b/);
    if (suffixMatch) {
      reasons.push(`'${suffixMatch[1].toUpperCase()}' suffix ignored`);
    }

    // Were dots added to a previously dotless SKU?
    if (!/\d\.\d/.test(original) && /\d\.\d/.test(normalized)) {
      reasons.push('dots added');
    }

    return reasons.join(' · ');
  }

  document.querySelectorAll('form[action$="/search"]').forEach(form => {
    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const hint = form.querySelector('[data-sku-hint]');
    const hintValue = form.querySelector('[data-sku-hint-value]');
    const hintReason = form.querySelector('[data-sku-hint-reason]');
    const dropdown = form.querySelector('.predictive-search--header, [data-predictive-search]');

    function syncDropdownOffset() {
      if (!dropdown) return;
      if (hint && !hint.hidden) {
        dropdown.style.marginTop = `${hint.offsetHeight + 6}px`;
      } else {
        dropdown.style.marginTop = '';
      }
    }

    input.addEventListener('input', e => {
      const original = e.target.value;
      const normalized = normalize(original);
      if (normalized !== original) {
        e.target.value = normalized;
        if (hint && hintValue) {
          const skuMatch = normalized.match(/\d{3}\.\d{3}\.\d{3}\.\d{3}/);
          hintValue.textContent = skuMatch ? skuMatch[0] : normalized;
          if (hintReason) {
            hintReason.textContent = getReason(original, normalized);
          }
          hint.hidden = false;
        }
      } else if (hint) {
        hint.hidden = true;
      }
      syncDropdownOffset();
    }, true);

    form.querySelector('button[type="reset"]')?.addEventListener('click', () => {
      if (hint) hint.hidden = true;
      syncDropdownOffset();
    });

    form.addEventListener('submit', () => {
      const original = input.value;
      const normalized = normalize(original);
      if (normalized !== original) {
        input.value = normalized;
        let hidden = form.querySelector('input[name="q_orig"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'q_orig';
          form.appendChild(hidden);
        }
        hidden.value = original;
      }
    });
  });

  // Direct URL navigation handling
  if (location.pathname.endsWith('/search')) {
    const url = new URL(location.href);
    const q = url.searchParams.get('q');
    if (q && q !== normalize(q)) {
      url.searchParams.set('q_orig', q);
      url.searchParams.set('q', normalize(q));
      location.replace(url.toString());
    }
  }
})();
